import { FormControl, Stack, Typography, TextField as MUITextField } from '@mui/material'
import { useExtendedAuth } from '@auth/hooks/useExtendedAuth'

export default function EsignStep() {
  const { user } = useExtendedAuth()

  const getSignerName = () => {
    const firstName = user?.profile.given_name || ''
    const lastName = user?.profile.family_name || ''
    let signerName = `${firstName} ${lastName}`.trim()

    if (!signerName) {
      signerName = user?.profile.email || user?.profile.preferred_username || ''
    }

    return signerName
  }

  return (
    <>
      <Stack alignItems="flex-start" alignSelf="stretch">
        <Typography variant="h6" color="text.primary">
          Sign to confirm
        </Typography>
        <Typography variant="body1" color="text.primary">
          Authentication is required to complete this action
        </Typography>
      </Stack>
      <FormControl fullWidth>
        <Stack spacing={2} alignSelf="stretch" paddingX={1}>
          <MUITextField
            label="Your Name"
            variant="outlined"
            fullWidth
            disabled
            value={getSignerName()}
            slotProps={{
              inputLabel: {
                shrink: true,
              },
            }}
          />
          <MUITextField
            label="Email"
            variant="outlined"
            fullWidth
            disabled
            value={user?.profile.preferred_username}
            slotProps={{
              inputLabel: {
                shrink: true,
              },
            }}
          />
        </Stack>
      </FormControl>
      <Typography variant="body2" color="text.secondary">
        For security purposes, you will need to re-authenticate to confirm this action.
      </Typography>
      <Typography variant="body2" color="text.secondary">
        **Regulatory: The electronic signatures in this system are intended to be the legally binding equivalent of the
        individual's handwritten signature.
      </Typography>
    </>
  )
}
